import React from 'react';
import { Row, Switch, styled } from '@teko/ds-desktop';
import { t } from 'i18n';
import { useDistanceTerminalContext } from 'contexts';
import { useGetDistanceTerminal } from '../useGetDistanceTerminal';

export const SwitchGetByGeoLocation = () => {
  const {
    isGetCurrentLocation,
    setIsGetCurrentLocation,
    setIsModeEnterAddress,
  } = useDistanceTerminalContext();
  const { requestLocation } = useGetDistanceTerminal();
  return (
    <>
      <Row justify="space-between">
        <Title>{t('Bật định vị – nhận ưu đãi đúng chỗ!')}</Title>
        <Switch
          checked={isGetCurrentLocation}
          onChange={() => {
            if (isGetCurrentLocation) {
              setIsGetCurrentLocation?.(false);
              setIsModeEnterAddress?.(true);
            } else {
              requestLocation(() => setIsGetCurrentLocation?.(true));
            }
          }}
        />
      </Row>
      <SubTitle style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
        {t(`Cho phép truy cập vị trí để tìm siêu thị gần nhất.`)}
      </SubTitle>
      <div style={{ marginTop: 4, marginBottom: 16 }}>
        <SubTitle style={{ textAlign: 'left' }}>
          {t(
            `Miễn phí vận chuyển trong phạm vi 6km với đơn hàng từ 200.000 đồng.`,
          )}
        </SubTitle>
      </div>
    </>
  );
};

const SubTitle = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

const Title = styled.span`
  font-size: 16x;
  font-weight: 500;
`;
